/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'

import {
  DatePicker,
  Icon,
  Select,
  message,
  Button,
  Popconfirm,
  Radio,
  Input,
  Divider,
  Checkbox,
  Tooltip,
  Modal,
  InputNumber,
  Tabs,
} from 'antd'
import {
  ExportComponent,
  getApiTargetInfo,
  getPermitActions,
  getUnits,
} from 'core'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Label,
  Title,
} from 'core/screen-util'
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { connect } from 'react-redux'
import R, { isNil } from 'ramda'
import {
  DatePickerContext,
  ErrorContext,
  JcTmpErrorContext,
  SpinContext,
  DataContext,
} from 'context'
import {
  createTurbinePerormanceWithEvents,
  deleteWind2TurbinePerformance,
  exportWindTurbinePerformanceData,
  getwind2EventTypes,
  updateMultipleCaucecodeTurbineEvent,
  wind2TurbinePowerData,
  windProcessEventAndPerformanceData,
  saveWind2TurbinePerformance,
} from './wind2api'
import {
  getSystemConfigurationInfo,
  getWind2AvaliableStatus,
  getWind2CauseCode,
  getWind2ContribCondtition,
  wind2EventUpdate,
  wind2PerformanceUpdate,
  wind2EventUpdateTurbine,
  wind2EventDelete,
  wind2EventDeleteTurbine,
  wind2ImpactAnalysis,
  wind2PlantSelection,
  wind2SubgroupFormation,
  wind2AllSubgroup,
} from 'api/pgads'
import Wind2EventDialog, { saveDateformat } from './Wind2EventDialog'
import { getTimeZone, getValidPlantList } from './wind2utils'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import {
  Grid,
  VirtualizedCell,
  defaultVirtualizedCellRender,
  extractAndFormatData,
  virtualizedGridRenderer,
  freeEditEngine,
} from '@integec/grid-tools'
import {
  Wind2NercEventHeaders,
  Wind2PerformanceHeaders,
  Wind2PerformanceHeadersModifier,
  Wind2TurbineEventHeaders,
  Wind2TurbinePerformanceHeaders,
  modifierCol,
} from './Headers'
import {
  exportDataComponent,
  hasAccesPermits,
  rowHeaderRender,
} from 'core/utils'
import Wind2TurbineEventDialog from './Wind2TurbineEventDialog'
import Wind2PerformanceDialog from './Wind2PerformanceDialog'
import Wind2TurbinePerformanceDialog from './Wind2TurbinePerformanceDialog'
import SolarInverterValidationDialog from './Wind2TurbineValidationDialog'
import moment from 'moment'
import ImpactAnalysisModal from './impactanalysis/ImpactAnalysis'
import { modifiedDateCol } from 'core/HeaderColTypeProps'
import {
  dateCol,
  dateTimeCol,
  numCol,
  strCol,
  intCol,
} from '@integec/grid-tools/lib/cols'

import { toXlsxColumns, toXlsxData, writeToExcel } from 'marginanalysis/Headers'
import { saveAs } from 'file-saver'
import * as ScreenPermissions from 'core/EventActions'
import {
  WIND2_UPDATE_CAUCECODE_TURBINEEVENT,
  WIND_ADMIN_POWER_DATA_20,
} from '../core/EventActions'
import FilterContext, {
  effectvieFilterCount,
  emptyFilterObj,
  getGridPropsObj,
} from '../context/FilterContext'
import MultiCauseCode from 'card-data/MultiCauseCode'

const Wind2TurbinePerformancePowerData = ({ targetInfo, actionPermits }) => {
  const [plantSelectionData, setPlantSelectionData] = useState([])
  const {
    selectedWind2Plant,
    setSelectedWind2Plant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedWind2Plant)
    ? selectedWind2Plant[0]
    : selectedWind2Plant

  const [plantList, setPlantList] = useState([])
  const [subGroupList, setSubGroupList] = useState([])
  const [performanceData, setPerformanceData] = useState([])
  const [nercPerformanceData, setNercPerformanceData] = useState([])
  const [turbineEventData, setturbineEventData] = useState([])
  const [runInfoStatus, setRunInfoStatus] = useState({
    isModificationExits: false,
    isModificationExitsTurbine: false,
  })

  const [selectedDate, setSelectedDate] = useState(moment().endOf('month'))
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const [isPerformacneSelected, setIsPerformacneSelected] = useState('P') //   p = per , e = inv event , n=nerc event

  const turbineEventGridRef = useRef()
  const turbinePerformanceGridRef = useRef()
  const nercPerformanceGridRef = useRef()
  const nercEventGridRef = useRef()

  const {
    setGridProps,
    setDrawerVisible,
    setFilterCondition,
    filterCondition,
  } = useContext(FilterContext)

  const [origData, setOrigData] = useState({ P: [], E: [], N: {}, NP: [] })

  const [isRetrived, setIsRetrieved] = useState(false)
  const [checkedValues, setCheckedValues] = useState(['E', 'P'])
  const [fuzzyFilter, setFuzzyFilter] = useState('')

  const [nercPerformanceRowSelected, setNercPerformanceRowSelected] = useState(
    []
  )
  const [showNercPerformanceDialog, setNercPerformanceDialog] = useState({})
  const [performanceRowSelected, setPerformanceRowSelected] = useState([])
  const [turbineSelected, setTurbineSelected] = useState([])

  const [showPerformanceDialog, setPerformanceDialog] = useState({})
  const [showTurbineEventDialog, setTurbineEventDialog] = useState({})
  const [showValidationDialog, setShowValidationDialog] = useState({})

  const [contribConditionList, setContribConditionList] = useState([])
  const [avaliablitilityStatusList, setAvalibilityStatusList] = useState([])
  const [turbineIdMap, setTurbineIdMap] = useState([])
  const [causecodeList, setCausecodeList] = useState([])

  const [eventSelected, setEventSelected] = useState([])
  const [showEventDialog, setEventDialog] = useState({})
  const [eventData, setEventData] = useState([])

  const [impactAnalysisDialog, setImpactAnalysisDialog] = useState(false)
  const [impactAnalysisData, setImpactAnalysisData] = useState({})
  const [recalcTurbineperf, setRecalcTurbinePerf] = useState('N')

  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )

  const hasWindPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [WIND_ADMIN_POWER_DATA_20],
        matchAny: true,
      }),
    [actionPermits]
  )

  const subGroupByPlant = useMemo(
    () => R.groupBy(d => d.plantId, subGroupList),
    [subGroupList]
  )

  const subGroupNameMap = useMemo(
    () =>
      R.fromPairs(
        R.map(
          d => [d.subgroupName, d.subgroupName],
          subGroupByPlant[plantSelected] || []
        )
      ),
    [subGroupByPlant, plantSelected]
  )

  const [systemConfiguration, setSystemConfiguration] = useState([])

  const isPlantLocked = useMemo(
    _ => {
      const total = (nercPerformanceData || []).find(
        s => s.subgroupName === 'TOTAL'
      ) || { action: 'U' }
      return total.action === 'L' || total.action === 'l'
    },
    [nercPerformanceData]
  )
  const [eventTypes, setEventTypes] = useState([])

  useEffect(
    _ => {
      getWind2AvaliableStatus(targetInfo).fork(_ => _, setAvalibilityStatusList)
      getwind2EventTypes(targetInfo).fork(_ => _, setEventTypes)
      getWind2ContribCondtition(targetInfo).fork(
        _ => _,
        setContribConditionList
      )
      wind2SubgroupFormation(targetInfo).fork(
        _ => _,
        data => {
          const byPlantId = R.compose(R.groupBy(d => d.plantId))(data)
          setTurbineIdMap(byPlantId)
        }
      )

      getWind2CauseCode(targetInfo).fork(
        _ => _,
        data => {
          const matchToSelct = data.map(
            ({ system, subsystem, causecode, description }) => ({
              system,
              component: subsystem,
              causeCode: causecode,
              description,
              unitCode: 'WI',
              unitType: 'WI',
              isOMC: false,
            })
          )
          setCausecodeList(matchToSelct)
        }
      )

      getSystemConfigurationInfo(targetInfo).fork(
        _ => _,
        setSystemConfiguration
      )

      wind2AllSubgroup(targetInfo).fork(setError, setSubGroupList)
    },
    [setError, targetInfo]
  )

  const avalibilityStatusIdMap = useMemo(
    _ => {
      return R.compose(
        R.fromPairs,
        R.map(({ avaliabilityStatusCode, avaliabilityStatusName }) => [
          avaliabilityStatusCode,
          avaliabilityStatusName,
        ])
      )(avaliablitilityStatusList)
    },
    [avaliablitilityStatusList]
  )

  useEffect(
    _ => {
      // make sort plantName
      // wind2PlantWithSubGroup(targetInfo).fork(setError, data => {
      //   const sd = R.sortBy(R.prop('plantName'), data)
      //   setPlantSelectionData(sd)
      //   if (!plantSelected && sd[0] && sd[0].plantId)
      //     setPlantSelected(sd[0].plantId)
      // })
      wind2PlantSelection(targetInfo)({
        year: selectedDate.format('YYYY'),
        month: selectedDate.format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
      })
    },
    [targetInfo, selectedDate, setError]
  )

  // useEffect(
  //   _ => {
  //     let stoList = []

  //     stoList = getValidPlantList(plantList, subGroupList, [])
  //     setPlantSelectionData(stoList)
  //     const isValidSelection = stoList.some(p => p.plantId === plantSelected);
  //     if (!isValidSelection && stoList[0] && stoList[0].plantId)
  //       setPlantSelected([stoList[0].plantId])
  //   },
  //   [plantList, plantSelected, setPlantSelected, subGroupList]
  // )

  useEffect(() => {
    const stoList = getValidPlantList(plantList, subGroupList, [])
    setPlantSelectionData(stoList)
    const isValidSelection = stoList.some(p => p.plantId === plantSelected)
    if (!isValidSelection && stoList[0] && stoList[0].plantId) {
      if (plantSelected !== stoList[0].plantId) {
        setPlantSelected([stoList[0].plantId])
      }
    }
  }, [plantList, plantSelected, setPlantSelected, subGroupList])

  const clearData = _ => {
    setNercPerformanceData([])
    setPerformanceData([])
    setturbineEventData([])
    setIsRetrieved(false)
    setPerformanceRowSelected([])
    setTurbineSelected([])
    setEventSelected([])
    setEventData([])
    setOrigData({ P: [], E: [], N: [], NP: [] })
    setFilterCondition([{}])
  }

  const isImpactIsSequence = useMemo(
    _ => {
      const mnt = moment()
        .startOf('month')
        .startOf('day')
      return !selectedDate
        .clone()
        .startOf('month')
        .startOf('day')
        .isAfter(mnt)
    },
    [selectedDate]
  )

  const getplantIdandEntityId = _ => {
    const sel = plantSelectionData.find(f => f.plantId === plantSelected)
    return {
      entityId: sel.entityId,
      plantId: sel.plantId,
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
    }
  }
  const getSelectedPlantDetails = useMemo(
    _ => {
      return plantSelectionData.find(f => f.plantId === plantSelected) || {}
    },
    [plantSelected, plantSelectionData]
  )
  const retrieveData = (dataChanged, cdate = selectedDate) => {
    if (dataChanged && editInfo.updated.length > 0) {
      setShowValidationDialog({
        visible: true,
        //  value: value, // passing the value to the modal
        onYes: updateData, // function to call when "Yes" is clicked
        onNo: retrieveData, // correctly passing value to onNo handler
      })
    } else {
      if (!plantSelected) {
        message.info('Please, Select Plant')
        return
      }
      setSpinning(true)
      wind2TurbinePowerData(targetInfo)({
        year: cdate.format('YYYY'),
        month: cdate.format('MM'),
        plantid: plantSelected,
      }).fork(setError, data => {
        setSpinning(false)
        setIsRetrieved(true)
        setFilterCondition([{}])
        setturbineEventData(data.turbineEvents)
        setEventData(data.nercEventData)
        let perfData = data.turbinePerformanceData

        perfData = R.sortBy((a, b) => {
          if ((a.subgroupName || '') === 'TOTAL') return 100000
          else {
            return R.toLower((a && a.subgroupName) || '').localeCompare(
              R.toLower((b && b.subgroupName) || '')
            )
          }
        }, perfData)

        setPerformanceData(perfData)

        let nercPerfData = data.performanceData

        nercPerfData = R.compose(
          R.sortBy((a, b) => {
            if ((a.subgroupName || '') === 'TOTAL') return 100000
            else {
              return R.toLower((a && a.subgroupName) || '').localeCompare(
                R.toLower((b && b.subgroupName) || '')
              )
            }
          })
          // R.filter(f => !isNil(f.subgroupId))
        )(nercPerfData)

        setNercPerformanceData(nercPerfData)
        setOrigData({
          P: perfData,
          E: data.turbineEvents,
          N: data.nercEventData,
          NP: nercPerfData,
        })
        const {
          lastModifiedDate,
          lastRunTime,
          isModificationExits,
          lastModifiedDateTurbine,
          lastRunTimeturbine,
          isModificationExitsTurbine,
        } = data
        setRunInfoStatus({
          lastModifiedDate,
          lastRunTime,
          isModificationExits,
          lastModifiedDateTurbine,
          lastRunTimeturbine,
          isModificationExitsTurbine,
        })
      })
    }
  }
  const TurbineHeaders = useCallback(
    (width, withPlantId = false) =>
      Wind2TurbineEventHeaders(
        width,
        contribConditionList,
        eventTypes,
        turbineIdMap[plantSelected],
        withPlantId
      ),
    [contribConditionList, eventTypes, plantSelected, turbineIdMap]
  )

  const wind2TurbinePerformanceHeadersFunc = useCallback(
    (withPlantId = false) =>
      Wind2TurbinePerformanceHeaders(turbineIdMap[plantSelected], withPlantId),
    [turbineIdMap, plantSelected]
  )
  const wind2TurbinePerformanceHeaders = useMemo(
    _ => wind2TurbinePerformanceHeadersFunc(false),
    [wind2TurbinePerformanceHeadersFunc]
  )
  const wind2TurbinePerformanceHeaderswithPlantID = useMemo(
    _ => wind2TurbinePerformanceHeadersFunc(true),
    [wind2TurbinePerformanceHeadersFunc]
  )

  const NercHeaders = useCallback(
    (width, withPlantId = false) =>
      Wind2NercEventHeaders(
        width,
        contribConditionList,
        eventTypes,
        withPlantId
      ),
    [contribConditionList, eventTypes]
  )

  const wind2PerformanceHeadersGrid = useCallback(
    (width, withPlantId = false) => {
      const columns = Wind2PerformanceHeaders(
        avalibilityStatusIdMap,
        subGroupNameMap,
        withPlantId
      )
      const finWidth = (width - 30) / columns.length

      const nc = columns.map(m => ({ ...m, width: m.width || finWidth }))
      return [...nc, modifierCol, modifiedDateCol]
    },
    [avalibilityStatusIdMap, subGroupNameMap]
  )

  const mapIsPerformacneSelected = {
    P: {
      data: performanceData,
      setData: setPerformanceData,
      updateApi: saveWind2TurbinePerformance,
      header: wind2TurbinePerformanceHeaders,
      exportHeader: wind2TurbinePerformanceHeaderswithPlantID,
      ref: turbinePerformanceGridRef,
      title: 'Turbine Performance',
    },
    NP: {
      data: nercPerformanceData,
      setData: setNercPerformanceData,
      updateApi: wind2PerformanceUpdate,
      header: wind2PerformanceHeadersGrid(30),
      exportHeader: wind2PerformanceHeadersGrid(30, true),
      ref: nercPerformanceGridRef,
      title: 'NERC Performance',
    },
    N: {
      data: eventData,
      setData: setEventData,
      updateApi: wind2EventUpdate,
      header: NercHeaders(30),
      exportHeader: NercHeaders(30, true),
      ref: nercEventGridRef,
      title: 'NERC Event',
    },
    E: {
      data: turbineEventData,
      setData: setturbineEventData,
      updateApi: wind2EventUpdateTurbine,
      header: TurbineHeaders(30),
      exportHeader: TurbineHeaders(30, true),
      ref: turbineEventGridRef,
      title: 'Turbine Event',
    },
  }

  const showTurbineEventUpdateDialog = _ => {
    if (turbineSelected.length > 1) {
      message.info('Please, Select only one row')
      return
    }
    setTurbineEventDialog({
      isNew: false,
      visible: true,
      data: {
        ...turbineSelected[0],
        action: 'U',
      },
    })
  }

  const deleteTurbineEvent = _ => {
    setSpinning(true)
    wind2EventDeleteTurbine(targetInfo)(turbineSelected).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data saved.')
          retrieveData()
        }
      }
    )
  }

  const updateData = _ => {
    const effectiveData = mapIsPerformacneSelected[isPerformacneSelected]?.data
    const updateApi = mapIsPerformacneSelected[isPerformacneSelected]?.updateApi
    const saveData = freeEditEngine.applyEdits({
      data: effectiveData?.filter(d => d.updated),
      editInfo,
    })

    if (saveData.length <= 0) {
      message.error('Please, update data')
      return
    }

    setSpinning(true)

    updateApi(targetInfo)(saveData).fork(setError, errorList => {
      setSpinning(false)
      if (errorList.length > 0) setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data updated.')
        setEditInfo(freeEditEngine.generateInitialEditInfo())
        retrieveData()
      }
    })
  }

  const showPerformanceUpdateDialog = _ => {
    if (performanceRowSelected.length > 1) {
      message.info('Please, Select only one row')
      return
    }
    setPerformanceDialog({
      isNew: false,
      visible: true,
      data: performanceRowSelected[0],
    })
  }

  const showNercPerformanceUpdateDialog = _ => {
    setNercPerformanceDialog({
      isNew: false,
      visible: true,
      data: nercPerformanceRowSelected[0],
    })
  }

  const performanceDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type
    if (headers[columnIndex].ident === 'turbineId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'modifier'),
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          // onDoubleClick={_ => {
          //   // onUpdate()
          //   !isPlantLocked && showPerformanceUpdateDialog()
          // }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }
    return defaultVirtualizedCellRender({
      ...props,
      style,
      editRender:
        type === 'date' || type === 'date-time' ? dateEditor : undefined,
    })
  }

  const nercPerformanceDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps

    if (headers[columnIndex].ident === 'subgroupName') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'modifier'),
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          onDoubleClick={_ => {
            // onUpdate()
            const isTtoal =
              nercPerformanceRowSelected[0] &&
              (nercPerformanceRowSelected[0].subgroupName === 'TOTAL' ||
                nercPerformanceRowSelected[0].inverterGroupName === 'TOTAL')
            if (!isTtoal && !R.isNil(isTtoal))
              !isPlantLocked && showNercPerformanceUpdateDialog()
          }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }
    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        const isTtoal =
          nercPerformanceRowSelected[0] &&
          (nercPerformanceRowSelected[0].subgroupName === 'TOTAL' ||
            nercPerformanceRowSelected[0].inverterGroupName === 'TOTAL')
        if (!isTtoal && !R.isNil(isTtoal))
          !isPlantLocked && showNercPerformanceUpdateDialog()
      },
    })
  }
  const deletePerformacneCall = _ => {
    setSpinning(true)
    deleteWind2TurbinePerformance(targetInfo)(performanceRowSelected).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data Deleted.')
          retrieveData()
        }
      }
    )
  }

  const insertPerformanceCall = _ => {
    setPerformanceDialog({
      isNew: true,
      visible: true,
      data: { ...getplantIdandEntityId() },
    })
  }

  const insertNercPerformanceCall = _ => {
    setNercPerformanceDialog({
      isNew: true,
      visible: true,
      data: { ...getplantIdandEntityId() },
    })
  }

  const deleteNercPerformacneCall = _ => {
    setSpinning(true)
    deleteWind2TurbinePerformance(targetInfo)(nercPerformanceRowSelected).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data Deleted.')
          retrieveData()
        }
      }
    )
  }

  const handleIsPerformacneSelected = value => {
    if (editInfo.updated.length > 0) {
      setShowValidationDialog({
        visible: true,
        value: value, // passing the value to the modal
        onYes: updateData, // function to call when "Yes" is clicked
        onNo: () => setIsPerformacneSelected(value), // correctly passing value to onNo handler
      })
    } else {
      setIsPerformacneSelected(value) // directly setting the value if no updates
    }
  }

  const isEditableComp = ({ header }) => {
    const { ident } = header
    // if (!isEditable) return false
    if (
      ident === 'modifier' ||
      ident === 'modifiedDate' ||
      ident === 'turbineId' ||
      ident === 'eventId'
    )
      return false
    return true
  }

  const editRow = editInfo => (data, setEditInfo, setData) => {
    const modData = data.map(d => {
      if (editInfo.updatedMap.get(d)) {
        return {
          ...editInfo.updatedMap.get(d),
          modificationInfo: undefined,
          updated: true,
        }
      } else {
        return d
      }
    })

    let editData = editInfo.updated
    editData = editData.map(d => ({
      ...d,
      modificationInfo: undefined,
    }))
    setEditInfo({ ...editInfo, updated: editData })
    setData(modData)
  }

  const dateEditor = props => {
    const { data, header, rowIndex, style, getInputProps, cancelEdit } = props
    const { onChange, value } = getInputProps({ refKey: 'innerRef' })
    return (
      <DatePicker
        value={value ? moment(value) : null}
        showTime={{
          format: 'h:mm',
          defaultValue: moment('00:00', 'HH:mm'),
        }}
        onChange={date => {
          const newEditInfo = freeEditEngine.updateRow({
            editInfo,
            currentRow: data[rowIndex],
            editedRow: {
              ...data[rowIndex],
              [header.ident]: date ? date.format(header.dataFormat) : null,
            },
          })
          // setEditDataInfo(newEditInfo)
          editRow(newEditInfo)(
            mapIsPerformacneSelected[isPerformacneSelected].data,
            setEditInfo,
            mapIsPerformacneSelected[isPerformacneSelected].setData
          )
          data[rowIndex][header.ident] = date
            ? date.format(header.dataFormat)
            : null
          onChange({
            target: { value: date ? date.format(header.dataFormat) : date },
          })
        }}
        style={{
          ...style,
          padding: `0px`,
          margin: `0px`,
          paddingLeft: `10px`,
          borderTop: `0px solid #fff`,
        }}
        format={header.displayFormat}
        size="small"
        onOpenChange={status => {
          if (!status) cancelEdit()
        }}
        allowClear={header.allowClear}
        suffixIcon={null}
        // bordered={false}
      />
    )
  }

  const inverterEventDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type

    if (headers[columnIndex].ident === 'eventId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'modifier'),
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          // onDoubleClick={_ => {
          //   // onUpdate()
          //   !isPlantLocked && showTurbineEventUpdateDialog()
          // }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }
    return defaultVirtualizedCellRender({
      ...props,
      style,
      // onDoubleClick: _ => {
      //   !isPlantLocked && showTurbineEventUpdateDialog()
      // },
      editRender:
        type === 'date' || type === 'date-time' ? dateEditor : undefined,
    })
  }

  const createAllturbineEvent = _ => {
    setSpinning(true)
    createTurbinePerormanceWithEvents(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, tmpError => {
      setSpinning(false)
      setTmpError(tmpError)
      if (!isErrorContains(tmpError)) {
        message.info('Process completed.')
        retrieveData()
      }
    })
  }

  const createTurbineData = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    if (isImpactIsSequence) {
      // message.info('Month is out of Sequence.')
      callImpactAnalysisApi(createAllturbineEvent, CREATE)
    } else {
      createAllturbineEvent()
    }
  }

  const callProcessEventAndPerformacne = _ => {
    windProcessEventAndPerformanceData(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      type:
        checkedValues.includes('P') && checkedValues.includes('E')
          ? 'A'
          : checkedValues[0],
    }).fork(setError, tmpError => {
      setSpinning(false)
      if (!isErrorContains(tmpError)) {
        message.info('Process finished.')
        retrieveData()
      }
      setTmpError(tmpError)
    })
  }

  const onProcessEventsBoth = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    if (checkedValues.length <= 0) {
      message.info('Please, Select Process Type')
      return
    }
    if (isImpactIsSequence) {
      // message.info('Month is out of Sequence.')
      callImpactAnalysisApi(callProcessEventAndPerformacne, PROCESS)
    } else {
      callProcessEventAndPerformacne()
    }
  }

  const onInsertNercEvent = _ => {
    setEventDialog({
      isNew: false,
      visible: true,
      data: {
        ...getplantIdandEntityId(),
        isNew: true,
        visible: true,
        action: 'A',
        eventtype: 'FO',
        eventstart: selectedDate
          .clone()
          .startOf('month')
          .format(saveDateformat),
        eventstartTimeZone: getTimeZone({
          pzone: getSelectedPlantDetails.timeZone,
          daylightSavings: getSelectedPlantDetails.daylightSaving,
          date: selectedDate.clone().startOf('month'),
        }),
      },
    })
  }

  const showNercEventUpdateDialog = _ => {
    if (eventSelected.length > 1) {
      message.info('Please, Select only one row')
      return
    }
    setEventDialog({
      isNew: false,
      visible: true,
      data: {
        ...getplantIdandEntityId(),
        ...eventSelected[0],
        action: 'U',
      },
    })
  }

  const deleteNercEvent = _ => {
    setSpinning(true)
    wind2EventDelete(targetInfo)(eventSelected).fork(setError, errorList => {
      setSpinning(false)
      setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data saved.')
        retrieveData()
      }
    })
  }

  const nercEventDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type
    if (headers[columnIndex].ident === 'eventId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'modifier'),
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          // onDoubleClick={_ => {
          //   // onUpdate()
          //   !isPlantLocked && showNercEventUpdateDialog()
          // }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }
    return defaultVirtualizedCellRender({
      ...props,
      style,
      // onDoubleClick: _ => {
      //   !isPlantLocked && showTurbineEventUpdateDialog()
      // },
      editRender:
        type === 'date' || type === 'date-time' ? dateEditor : undefined,
    })
  }

  const impactAnalysisApi = createorprocess =>
    wind2ImpactAnalysis(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      mode: 'ANALYZE',
      createorprocess,
      recalcTurbineperf,
    })

  // impact found means it s the error
  // const isImpactANalysisError = summary => summary.find(f => f.impactYN === 'Y')

  const CREATE = 'CREATE'
  const PROCESS = 'PROCESS'

  const callImpactAnalysisApi = (mainCall, createorprocess) => {
    setSpinning(true)
    impactAnalysisApi(createorprocess).fork(setError, data => {
      setSpinning(false)

      const { impactSummary = [] } = data
      const isNotValidDAta = impactSummary.filter(
        f => f.tabId === '0' && f.impactYn === 'Y'
      )

      if (isNotValidDAta.length > 0) {
        // mainCall()
        setImpactAnalysisDialog(true)
        setImpactAnalysisData({ ...data, createorprocess })
      } else {
        message.info('All events and performance data are up to date.')
      }
    })
  }

  const impactAnalysisExecuteApi = createorprocess =>
    wind2ImpactAnalysis(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      mode: 'EXECUTE',
      createorprocess,
      recalcTurbineperf,
    })

  const Wind2TmpNercDataReportHeaders = [
    strCol({
      ident: 'plantId',
      display: 'Plant Id',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    dateTimeCol({
      ident: 'periodFrom',
      display: 'Period From',
      isFiltered: true,
      sortOrder: 'asc',
      width: 250,
    }),
    dateTimeCol({
      ident: 'periodTo',
      display: 'Period To',
      isFiltered: true,
      sortOrder: 'asc',
      width: 250,
    }),
    strCol({
      ident: 'nercEvent',
      display: 'Nerc Event',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    intCol({
      ident: 'causecode',
      display: 'Cause Code',
      width: 150,
      ellipsis: true,
    }),
    strCol({
      ident: 'description',
      display: 'Description',
      width: 700,
      ellipsis: true,
    }),
    numCol({
      ident: 'foReduction',
      display: 'FO Reduction',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    numCol({
      ident: 'foNadir',
      display: 'FO Nadir',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    numCol({
      ident: 'foPercentRecovered',
      display: 'Fo Percent Recovered',
      isFiltered: true,
      sortOrder: 'asc',
      width: 250,
    }),
    numCol({
      ident: 'cumulativeMwhLoss',
      display: 'Cumulative MWh Loss',
      isFiltered: true,
      sortOrder: 'asc',
      width: 200,
    }),
  ]

  const exportData = async data => {
    const exportHeader = Wind2TmpNercDataReportHeaders

    const columns = toXlsxColumns(exportHeader)
    setSpinning(true)

    const ed = toXlsxData(data, exportHeader)

    const worksheet = [
      {
        name: 'nerc-data',
        columns,
        data: ed,
        metaInfo: [],
        colorInfo: [],
      },
    ]

    const fileBlob = await writeToExcel(worksheet)
    setSpinning(false)
    saveAs(fileBlob, 'nerc-data')
  }

  const exportNercData = (_, cdate = selectedDate) => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    setSpinning(true)
    exportWindTurbinePerformanceData(targetInfo)({
      year: cdate.format('YYYY'),
      month: cdate.format('MM'),
      plantid: plantSelected,
      mode: 'ANALYZE',
    }).fork(setError, data => {
      setSpinning(false)
      exportData(data)
    })
  }

  const showReCreateButton = useMemo(
    _ => {
      const screenPermission = hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND_IMPORT_CSV_20],
        matchAny: true,
      })

      const isNercEvent =
        (
          systemConfiguration.find(
            s =>
              s.key === 'WIND2_IMPORT_NERC_EVENT' ||
              s.key === 'WIND2_IMPORT_XML_NERC_EVENT'
          ) || { value: 'YES' }
        ).value.toUpperCase() === 'YES'
      const isNercPerf =
        (
          systemConfiguration.find(
            s =>
              s.key === 'WIND2_IMPORT_NERC_PERFORMANCE' ||
              s.key === 'WIND2_IMPORT_XML_NERC_PERFORMANCE'
          ) || { value: 'YES' }
        ).value.toUpperCase() === 'YES'

      const hideButton = screenPermission && isNercEvent && isNercPerf
      return !hideButton
    },
    [actionPermits, systemConfiguration]
  )

  const showRecalcCheckbox = useMemo(
    _ => {
      const isShowRecalcCheckbox =
        (
          systemConfiguration.find(
            s => s.key === 'WIND2_RECALC_PERF_ON_PROCESS'
          ) || {
            value: 'NO',
          }
        ).value.toUpperCase() === 'YES'
      return isShowRecalcCheckbox
    },
    [systemConfiguration]
  )

  const [
    showInverterEventUpdateCauseCodechnagedialog,
    setShowInverterEventUpdateCauseCodechnagedialog,
  ] = useState(false)

  const JobSProcessInfo = ({ recalcTurbineperf, setRecalcTurbinePerf }) => {
    // const importStatusData = {}
    // const createStatusData = {}
    if (!hasWindPowerDataWritePermission) return <div />

    // const {
    //   lastModifiedDate,
    //   lastRunTime,
    //   isModificationExits,
    //   lastModifiedDateTurbine,
    //   lastRunTimeturbine,
    //   isModificationExitsTurbine,
    // } = runInfoStatus

    return (
      <Content
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          gap: 5,
          marginTop: '10px',
          paddingBottom: '10px',
          paddingTop: '10px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns1: '100px 150px 200px 10px 200px',
            gridTemplateColumns: '200px auto',
            gridTemplateRows: '40px auto auto',
          }}
        >
          {/* <div style={{ textAlign: 'center' }}>
            <h3>Status</h3>
          </div>
          <div>
            <h3>Job Status/Time</h3>
          </div>
          <div style={{ textAlign: 'center' }}>
            <h3>Info</h3>
          </div> */}
          <div style={{ textAlign: 'center' }}>
            <h3>Run Job</h3>
          </div>

          <div />
          <Button
            type="primary"
            onClick={createTurbineData}
            icon="database"
            style={{ width: '100%' }}
            disabled={!isImpactIsSequence}
          >
            Create All Data
          </Button>
          <div />
          <div style={{ gridColumnEnd: 'span 2' }}>
            This process will create Turbine level and NERC level Events and
            Performance Data. All existing manually edited data will be
            replaced. An impact analysis will be presented before executing.
          </div>
        </div>
        <Divider type="vertical" style={{ height: '100%' }} />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 210px auto',
            gap: '10px',
          }}
        >
          <div
            style={{
              gridRowEnd: 'span 1',
              display: 'grid',
              justifyItems: 'center',
              alignContent: 'baseline',
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <h3>Process Job</h3>
            </div>
            {showReCreateButton ? (
              <Button
                type="primary"
                onClick={onProcessEventsBoth}
                disabled={!isImpactIsSequence}
                icon="database"
              >
                Recreate NERC Data
              </Button>
            ) : (
              <div />
            )}
          </div>

          <div>
            <div style={{ height: '30px' }} />
            <Tooltip title="When selected process will update the turbine level performance data based on turbine events.">
              <Checkbox
                style={{ padding: '5px 0px' }}
                checked={recalcTurbineperf === 'Y'}
                onChange={e =>
                  setRecalcTurbinePerf(e.target.checked ? 'Y' : 'N')
                }
                disabled={
                  !isImpactIsSequence || !(isRetrived && !isPlantLocked)
                }
              >
                Recalc Turbine Performance
              </Checkbox>
            </Tooltip>
          </div>

          <div style={{ gridColumnEnd: 'span 3' }}>
            This process will regenerate NERC Event and Performance Data using
            existing Turbine level data, including manually edited records. An
            impact analysis will be presented before executing.
          </div>
        </div>
      </Content>
    )
  }

  useEffect(
    _ => {
      const curData = origData[isPerformacneSelected]
      if (isPerformacneSelected === 'P') {
        // edit=editInfo => (data, setEditInfo, setData)

        setGridProps(
          getGridPropsObj(
            wind2TurbinePerformanceHeaders,
            curData,
            setPerformanceData
            // data=> editRow(editInfo) (data,setEditInfo,setPerformanceData)
          )
        )
      } else if (isPerformacneSelected === 'E') {
        setGridProps(
          getGridPropsObj(TurbineHeaders(30), curData, setturbineEventData)
        )
      } else if (isPerformacneSelected === 'N') {
        // const call = data => editRow(editInfo)(data, setEditInfo, setEventData)
        // const call = data => {
        //   const dt = data.map(d => {
        //     if (editInfo.updatedMap.get(d)) {
        //       return {
        //         ...editInfo.updatedMap.get(d),
        //         updated: true,
        //       }
        //     } else {
        //       return d
        //     }
        //   })
        //   setEventData(dt)
        // }
        setGridProps(getGridPropsObj(NercHeaders(30), curData, setEventData))
      } else if (isPerformacneSelected === 'NP') {
        setGridProps(
          getGridPropsObj(
            wind2PerformanceHeadersGrid(30),
            curData,
            setNercPerformanceData
          )
        )
      }
    },
    [
      NercHeaders,
      TurbineHeaders,
      isPerformacneSelected,
      origData,
      setGridProps,
      wind2PerformanceHeadersGrid,
      wind2TurbinePerformanceHeaders,
    ]
  )

  const openFilterDialog = e => {
    if (editInfo.updated.length > 0) {
      message.warn('Please, Save data')
      return
    }
    setDrawerVisible(true)
  }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  //     [
  //       EventHeader,
  //       NercPerformanceHeaderFormater,
  //       PerformanceHeaderFormater,
  //       SolarInverterEventHeaders,
  //       isPerformacneSelected,
  //       origData,
  //       setGridProps,
  //       // editInfo, // removed all the filters after its call bcoz of editinfo
  //     ]
  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '350px 300px 200px 200px 150px auto auto',
            gap: '10px',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Title>Wind Turbine Performance</Title>

          <Select
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              setPlantSelected([plantId])
              clearData()
            }}
          >
            {plantSelectionData.map(({ plantName, plantId }) => (
              <Select.Option key={plantId} value={plantId}>
                {plantName}
              </Select.Option>
            ))}
          </Select>
          <DatePicker.MonthPicker
            allowClear={false}
            style={{ width: '100%' }}
            format="MMMM-YYYY"
            value={selectedDate}
            onChange={d => {
              clearData()
              setSelectedDate(d.endOf('month'))
            }}
          />

          <Button.Group style={{ minWidth: '130px', marginLeft: '10px' }}>
            <Button
              title="Previous Month"
              style={{ marginLeft: '10px' }}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .subtract(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData(true, dt)
              }}
            >
              <Icon type="left" />
            </Button>

            <Button
              title="Next Month"
              style={{}}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .add(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData(true, dt)
              }}
            >
              <Icon type="right" />
            </Button>
          </Button.Group>
          <Button
            type="primary"
            onClick={() => retrieveData(true)}
            icon="database"
            style={{ width: '100%', height: '100%' }}
          >
            Retrieve
          </Button>
          <Button
            onClick={openFilterDialog}
            type="dashed"
            icon="filter"
            disabled={!isRetrived}
          >
            Filter Data ({effectvieFilterCount(filterCondition)})
          </Button>
        </div>
        <Filler />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            minWidth: '200px',
            width: '200px',
          }}
        >
          {isRetrived && (
            <div style={{ display: 'flex', width: '200px' }}>
              <Label>
                <b>Plant Status : </b>
              </Label>
              <Icon
                type={isPlantLocked ? 'lock' : 'unlock'}
                style={{
                  fontSize: '30px',
                }}
                theme="twoTone"
              />
            </div>
          )}
        </div>
        <Filler />
        <div style={{ display: 'grid', justifyContent: 'end' }}>
          <Button
            type={isRetrived ? 'primary' : 'default'}
            // onClick={exportNercData}
            onClick={exportNercData}
            disabled={!isRetrived}
            icon="database"
            style={{
              marginLeft: '20px',
              backgroundColor: isRetrived ? 'green' : undefined,
            }}
          >
            NERC Event Audit
          </Button>
        </div>

        <ExportComponent
          getData={_ =>
            exportDataComponent(
              mapIsPerformacneSelected[isPerformacneSelected].ref,
              mapIsPerformacneSelected[isPerformacneSelected].data,
              mapIsPerformacneSelected[isPerformacneSelected].exportHeader ||
                mapIsPerformacneSelected[isPerformacneSelected].header
            )
          }
          data={mapIsPerformacneSelected[isPerformacneSelected].data}
          headers={
            mapIsPerformacneSelected[isPerformacneSelected].exportHeader ||
            mapIsPerformacneSelected[isPerformacneSelected].header
          }
          fileName={mapIsPerformacneSelected[isPerformacneSelected].title}
          btnStyle={{ marginRight: '10px', marginLeft: '10px' }}
          disabled={
            !!(
              mapIsPerformacneSelected[isPerformacneSelected].data &&
              mapIsPerformacneSelected[isPerformacneSelected].data.length <= 0
            )
          }
        />
      </CriteriaRow>
      <JobSProcessInfo
        recalcTurbineperf={recalcTurbineperf}
        setRecalcTurbinePerf={setRecalcTurbinePerf}
      />
      <FullHeightSizer
        heightOffset={hasWindPowerDataWritePermission ? 350 : 200}
        widthOffset={50}
      >
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <div
              style={{
                gap: '15px',
                display: 'grid',
                gridTemplateColumns:
                  '350px 1fr 250px 100px 100px  100px 150px 150px',
                paddingRight: '40px',
                alignItems: 'baseline',
                alignContent: 'center',
                gridColumnEnd: 'span 2',
                justifyContent: 'end',
                width: '100%',
                margin: '5px',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'max-content 300px',
                  gap: '5px',
                }}
              >
                <Label>Select : </Label>
                <Select
                  onChange={value => handleIsPerformacneSelected(value)}
                  value={isPerformacneSelected}
                  width={300}
                >
                  <Select.Option value="NP">NERC Performance</Select.Option>
                  <Select.Option value="P">Turbine Performance</Select.Option>
                  <Select.Option value="N">NERC Events</Select.Option>
                  <Select.Option value="E">Turbine Events</Select.Option>
                </Select>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '10px 90px 50px 150px 50px 10px',
                  justifyContent: 'center',
                  gap: '5px',
                }}
              >
                <Divider
                  type="vertical"
                  style={{ height: '100%', backgroundColor: '#8080807a' }}
                />
                <div style={{ textAlign: 'end' }}>Automated</div>
                <div
                  style={{
                    backgroundColor: '#c5e0b4',
                    border: '0px solid black',
                    textAlign: 'center',
                    fontWeight: '700',
                    color: '#c5e0b4',
                    height: '70%',
                    alignSelf: 'center',
                  }}
                />
                <div style={{ textAlign: 'end' }}>Manually Updated</div>
                <div
                  style={{
                    backgroundColor: '#ffff00',
                    border: '0px solid black',
                    textAlign: 'center',
                    fontWeight: '700',
                    color: '#ffff00',
                    height: '70%',
                    alignSelf: 'center',
                  }}
                />
                <Divider
                  type="vertical"
                  style={{ height: '100%', backgroundColor: '#8080807a' }}
                />
              </div>
              <Input.Search
                placeholder="Filter"
                value={fuzzyFilter}
                style={{
                  gridColumnEnd: 'span 1',
                }}
                onChange={e => setFuzzyFilter(e.target.value)}
              />
              {isPerformacneSelected === 'N' && (
                <React.Fragment>
                  {hasWindPowerDataWritePermission && (
                    <Button
                      key="na"
                      onClick={onInsertNercEvent}
                      disabled={!(isRetrived && !isPlantLocked)}
                      type="primary"
                    >
                      Add
                    </Button>
                  )}
                  <Button
                    key="2"
                    style={{ width: '100%', paddingRight: '10px' }}
                    disabled={
                      !(
                        isRetrived &&
                        eventSelected.length > 0 &&
                        !isPlantLocked
                      )
                    }
                    onClick={showNercEventUpdateDialog}
                    type="primary"
                  >
                    {hasWindPowerDataWritePermission ? 'Update' : 'View'}
                  </Button>
                  {hasWindPowerDataWritePermission && (
                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          !editInfo.updated.length <= 0
                        )
                      }
                      onClick={updateData}
                      type="primary"
                    >
                      Save
                    </Button>
                  )}
                  {hasWindPowerDataWritePermission && (
                    <Popconfirm
                      key="3"
                      title="Delete the Event ?"
                      description="Are you sure to delete this Event?"
                      onConfirm={deleteNercEvent}
                      onCancel={_ => _}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                      disabled={
                        !(
                          isRetrived &&
                          eventSelected.length > 0 &&
                          !isPlantLocked
                        )
                      }
                    >
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            eventSelected.length > 0 &&
                            !isPlantLocked
                          )
                        }
                        type="danger"
                        style={{ width: '100%' }}
                      >
                        Delete
                      </Button>
                    </Popconfirm>
                  )}
                </React.Fragment>
              )}

              {isPerformacneSelected === 'P' && (
                <React.Fragment>
                  {hasWindPowerDataWritePermission && (
                    <Button
                      key="1"
                      style={{ width: '100%', paddingRight: '10px' }}
                      onClick={insertPerformanceCall}
                      disabled={!(isRetrived && !isPlantLocked)}
                      type="primary"
                    >
                      Add
                    </Button>
                  )}
                  <Button
                    key="2"
                    style={{ width: '100%', paddingRight: '10px' }}
                    disabled={
                      !(
                        isRetrived &&
                        performanceRowSelected.length > 0 &&
                        !isPlantLocked
                      )
                    }
                    onClick={showPerformanceUpdateDialog}
                    type="primary"
                  >
                    {hasWindPowerDataWritePermission ? 'Update' : 'View'}
                  </Button>
                  {hasWindPowerDataWritePermission && (
                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          !editInfo.updated.length <= 0
                        )
                      }
                      onClick={updateData}
                      type="primary"
                    >
                      Save
                    </Button>
                  )}
                  {hasWindPowerDataWritePermission && (
                    <Popconfirm
                      key="3"
                      title="Delete the Performance ?"
                      description="Are you sure to delete this Performance?"
                      onConfirm={deletePerformacneCall}
                      onCancel={_ => _}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                      disabled={
                        !(
                          isRetrived &&
                          performanceRowSelected.length > 0 &&
                          !isPlantLocked
                        )
                      }
                    >
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            performanceRowSelected.length > 0 &&
                            !isPlantLocked
                          )
                        }
                        type="danger"
                        style={{ width: '100%' }}
                      >
                        Delete
                      </Button>
                    </Popconfirm>
                  )}
                </React.Fragment>
              )}
              {isPerformacneSelected === 'NP' && (
                <React.Fragment>
                  <Button
                    key="2"
                    style={{ width: '100%', paddingRight: '10px' }}
                    disabled={
                      !(
                        isRetrived &&
                        nercPerformanceRowSelected.length > 0 &&
                        !isPlantLocked
                      )
                    }
                    onClick={showNercPerformanceUpdateDialog}
                    type="primary"
                  >
                    {hasWindPowerDataWritePermission ? 'Update' : 'View'}
                  </Button>
                </React.Fragment>
              )}

              {isPerformacneSelected === 'E' && (
                <React.Fragment>
                  {hasWindPowerDataWritePermission && (
                    <Button
                      disabled={!(isRetrived && !isPlantLocked)}
                      type="primary"
                      onClick={_ => {
                        setTurbineEventDialog({
                          isNew: true,
                          visible: true,
                          data: {
                            ...getplantIdandEntityId(),
                            action: 'A',
                            eventtype: 'FO',
                            eventstart: selectedDate
                              .clone()
                              .startOf('month')
                              .format(saveDateformat),
                            eventstartTimeZone: getTimeZone({
                              pzone: getSelectedPlantDetails.timeZone,
                              daylightSavings:
                                getSelectedPlantDetails.daylightSaving,
                              date: selectedDate
                                .clone()
                                .startOf('month')
                                .format(saveDateformat),
                              sortOrder: 'asc',
                            }),
                          },
                        })
                      }}
                    >
                      Add
                    </Button>
                  )}
                  <Button
                    disabled={
                      !(
                        isRetrived &&
                        turbineSelected.length > 0 &&
                        !isPlantLocked
                      )
                    }
                    onClick={showTurbineEventUpdateDialog}
                    type="primary"
                  >
                    {hasWindPowerDataWritePermission ? 'Update' : 'View'}
                  </Button>
                  {hasWindPowerDataWritePermission && (
                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          !editInfo.updated.length <= 0
                        )
                      }
                      onClick={updateData}
                      type="primary"
                    >
                      Save
                    </Button>
                  )}
                  {hasWindPowerDataWritePermission && (
                    <Popconfirm
                      title="Delete the Event ?"
                      description="Are you sure to delete this Event?"
                      onConfirm={deleteTurbineEvent}
                      onCancel={_ => _}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                      disabled={
                        !(
                          isRetrived &&
                          turbineSelected.length > 0 &&
                          !isPlantLocked
                        )
                      }
                    >
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            turbineSelected.length > 0 &&
                            !isPlantLocked
                          )
                        }
                        type="danger"
                        style={{ width: '100%' }}
                      >
                        Delete
                      </Button>
                    </Popconfirm>
                  )}
                  {hasWindPowerDataWritePermission && (
                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          turbineEventData?.length > 0
                        )
                      }
                      onClick={_ =>
                        setShowInverterEventUpdateCauseCodechnagedialog(true)
                      }
                      type="primary"
                    >
                      Update Cause Code
                    </Button>
                  )}
                </React.Fragment>
              )}
            </div>

            {isPerformacneSelected === 'NP' && (
              <Grid
                ref={nercPerformanceGridRef}
                sortEnabled
                data={nercPerformanceData}
                headers={wind2PerformanceHeadersGrid(width)}
                altBy={u => u.subgroupName}
                altBgColor="#ebebeb"
                // onEditInfoChange={info => editRow(info)}
                // editInfo={editInfo}
                render={virtualizedGridRenderer({
                  autoFixColByKey: false,
                  rowHeaderRender,
                  height: height - 70,
                  width: width - 30,
                  cellRender: nercPerformanceDoubleClick,
                })}
                //   fuzzyFilter={fuzzyFilter}
                isEditable={false}
                onSelectionChange={({ selectedRows }) => {
                  if (
                    selectedRows[0] &&
                    selectedRows[0].subgroupName === 'TOTAL'
                  )
                    setNercPerformanceRowSelected([])
                  else setNercPerformanceRowSelected(selectedRows)
                }}
                selectionMode="single"
                selectionType="row"
                initialSortOptions={wind2PerformanceHeadersGrid(width)}
                fuzzyFilter={fuzzyFilter}
              />
            )}
            {isPerformacneSelected === 'P' && (
              <div style={{ minHeight: '250px', gridColumnEnd: 'span 2' }}>
                <Grid
                  ref={turbinePerformanceGridRef}
                  sortEnabled
                  data={performanceData}
                  headers={wind2TurbinePerformanceHeaders}
                  altBy={u => u.turbineId}
                  altBgColor="#ebebeb"
                  onEditInfoChange={info =>
                    editRow(info)(
                      performanceData,
                      setEditInfo,
                      setPerformanceData
                    )
                  }
                  editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 70,
                    width: width - 30,
                    cellRender: performanceDoubleClick,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={!isPlantLocked && isEditableComp}
                  onSelectionChange={({ selectedRows }) => {
                    if (
                      selectedRows[0] &&
                      selectedRows[0].subgroupName === 'TOTAL'
                    )
                      setPerformanceRowSelected([])
                    else setPerformanceRowSelected(selectedRows)
                  }}
                  selectionMode="multi"
                  // selectionType="row"
                  editMode="cell"
                  initialSortOptions={wind2TurbinePerformanceHeaders}
                />
              </div>
            )}

            {isPerformacneSelected === 'E' && (
              <div style={{ height: 300 - 20 }}>
                <Grid
                  ref={turbineEventGridRef}
                  data={turbineEventData}
                  headers={TurbineHeaders(width - 40)}
                  altBy={u => u.entityId}
                  altBgColor="#ebebeb"
                  onEditInfoChange={info =>
                    editRow(info)(
                      turbineEventData,
                      setEditInfo,
                      setturbineEventData
                    )
                  }
                  editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    headerRowHeight: 30,
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 70,
                    width: width - 30,
                    cellRender: inverterEventDoubleClick,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={!isPlantLocked && isEditableComp}
                  onSelectionChange={({ selectedRows }) => {
                    setTurbineSelected(selectedRows)
                  }}
                  selectionMode="multi"
                  // selectionType="row"
                  initialSortOptions={[
                    {
                      ident: 'turbineId',
                      display: 'Turbine ID',
                      isKey: true,
                      sortOrder: 'asc',
                    },
                    // {
                    //   ident: 'eventId',
                    //   display: 'EventId',
                    //   isFiltered: true,
                    //   sortOrder: 'asc',
                    // },
                    { ident: 'eventstart', sortOrder: 'asc' },
                    // { ident: 'eventend', sortOrder: 'asc' },
                  ]}
                  // sortOptions={[
                  //   { ident: 'eventstart', sortOrder: 'asc' },
                  //   { ident: 'eventend', sortOrder: 'asc' },
                  // ]}
                  editMode="cell"
                  sortEnabled
                />
              </div>
            )}
            {isPerformacneSelected === 'N' && (
              <div style={{ height: 300 - 20 }}>
                <Grid
                  ref={nercEventGridRef}
                  data={eventData}
                  headers={NercHeaders(width - 20)}
                  altBy={u => u.eventId}
                  altBgColor="#ebebeb"
                  onEditInfoChange={info =>
                    editRow(info)(eventData, setEditInfo, setEventData)
                  }
                  editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 70,
                    width: width - 30,
                    headerRowHeight: 30,

                    cellRender: nercEventDoubleClick,
                  })}
                  //   fuzzyFilter={fuzzyFilter}
                  isEditable={!isPlantLocked && isEditableComp}
                  onSelectionChange={({ selectedRows }) => {
                    setEventSelected(selectedRows)
                  }}
                  fuzzyFilter={fuzzyFilter}
                  selectionMode="multi"
                  // selectionType="row"
                  editMode="cell"
                  initialSortOptions={NercHeaders(width)}
                  // sortOptions={NercHeaders(width)}
                />
              </div>
            )}
          </Content>
        )}
      </FullHeightSizer>
      {showTurbineEventDialog.visible && (
        <Wind2TurbineEventDialog
          {...showTurbineEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setTurbineEventDialog({})
          }}
          onRetrieve={retrieveData}
          causeCodeList={causecodeList}
          setTmpError={setTmpError}
          contribConditionList={contribConditionList}
          turbineList={turbineIdMap[plantSelected] || []}
          selectedPlantDetails={getSelectedPlantDetails}
          eventTypes={eventTypes}
        />
      )}
      {showPerformanceDialog.visible && (
        <Wind2TurbinePerformanceDialog
          {...showPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          setError={setError}
          avalibilityStatusIdMap={avalibilityStatusIdMap}
          avaliablitilityStatusList={avaliablitilityStatusList}
          turbineList={turbineIdMap[plantSelected] || []}
        />
      )}
      {showEventDialog.visible && (
        <Wind2EventDialog
          {...showEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setEventDialog({})
          }}
          onRetrieve={retrieveData}
          causeCodeList={causecodeList}
          contribConditionList={contribConditionList}
          selectedPlantDetails={getSelectedPlantDetails}
          eventTypes={eventTypes}
        />
      )}
      {impactAnalysisDialog && (
        <ImpactAnalysisModal
          targetInfo={targetInfo}
          data={impactAnalysisData}
          createorprocess={impactAnalysisData.createorprocess}
          onClose={_ => setImpactAnalysisDialog(false)}
          visible={impactAnalysisDialog}
          setSpinning={setSpinning}
          spinning={spinning}
          request={{
            year: selectedDate.format('YYYY'),
            month: selectedDate.format('MM'),
            plantid: plantSelected,
            mode: 'ANALYZE',
            plantName: (
              plantSelectionData.find(f => f.plantId === plantSelected) || {}
            ).plantName,
          }}
          setError={setError}
          // setImpactAnalysisData={setImpactAnalysisData}
          impactAnalysisExecuteApi={impactAnalysisExecuteApi}
          impactAnalysisApi={impactAnalysisApi}
          retrieveData={retrieveData}
          setTmpError={setTmpError}
        />
      )}
      {showNercPerformanceDialog.visible && (
        <Wind2PerformanceDialog
          {...showNercPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setNercPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          setError={setError}
          avalibilityStatusIdMap={avalibilityStatusIdMap}
          avaliablitilityStatusList={avaliablitilityStatusList}
        />
      )}
      {showValidationDialog.visible && (
        <SolarInverterValidationDialog
          {...showValidationDialog}
          // visible
          onHide={_ => {
            setShowValidationDialog({})
          }}
          onRevertData={() => {
            setShowValidationDialog({})
            setEditInfo(freeEditEngine.generateInitialEditInfo())
          }}
        />
      )}
      {showInverterEventUpdateCauseCodechnagedialog && (
        <TurbineEventCauseCodeChangeDialog
          targetInfo={targetInfo}
          visible={showInverterEventUpdateCauseCodechnagedialog}
          eventTypes={eventTypes}
          setVisible={_ =>
            setShowInverterEventUpdateCauseCodechnagedialog(false)
          }
          plantId={plantSelected}
          curMonth={selectedDate}
          inverterIdBYPlant={turbineIdMap[plantSelected]}
          causeCodeList={causecodeList}
          setError={setError}
          setJcListError={setTmpError}
          onRetrieve={retrieveData}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
  // envConfig: getEnvConfig(state),
})
export default connect(mapStateToProps)(Wind2TurbinePerformancePowerData)

const TurbineEventCauseCodeChangeDialog = ({
  targetInfo,
  visible,
  eventTypes,
  setVisible,
  plantId,
  curMonth,
  inverterIdBYPlant,
  causeCodeList,
  setError,
  setJcListError,
  onRetrieve,
}) => {
  const startMonth = curMonth.clone().startOf('month')
  const endMonth = curMonth.clone().endOf('month')
  const [data, setData] = useState({
    plantId,
    turbineIds: [],
    startDate: curMonth.clone().startOf('month'),
    endDate: curMonth.clone().endOf('month'),
    eventtype: ['FO'],
  })

  const onOk = _ => {
    if (data.turbineIds.length <= 0) {
      message.warn('Please, Select Turbine Id')
      return
    } else if (eventTypes.length <= 0) {
      message.warn('Please, Select Event Type')
      return
    } else if (!data.causecode) {
      message.warn('Please, Select Causecode')
      return
    }
    const effData = {
      ...data,
      eventtype: data.eventtype.includes('ALL')
        ? efffEventType.map(({ id }) => id)
        : data.eventtype,
      turbineIds: data.turbineIds.includes('ALL')
        ? inverterIdBYPlant.map(({ turbineId }) => turbineId)
        : data.turbineIds,
    }
    updateMultipleCaucecodeTurbineEvent(targetInfo)({
      ...effData,
      startDate: data.startDate.format('MM/DD/YYYY'),
      endDate: data.endDate.format('MM/DD/YYYY'),
    }).fork(setError, data => {
      setJcListError(data)
      if (!isErrorContains(data)) {
        message.info('Data saved.')
        setVisible(false)
        onRetrieve()
      }
    })
  }

  const efffEventType = eventTypes.filter(f => f.eventFor === 'T')

  const [causeCodeDialog, setCauseCodedialog] = useState({
    causeCodeDialog: false,
  })

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setData({
      ...data,
      causecode: causeCodeValues[0] && causeCodeValues[0].causeCode,
    })
    setCauseCodedialog({
      causeCodeDialog: false,
      causeCodeKeyValues,
      causeCodeValues,
      causecode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : data.causecode,
    })
  }

  const onCauseCodeTreeCancel = causeCodeKeyValues => {
    setCauseCodedialog({
      causeCodeKeyValues,
      causeCodeDialog: false,
    })
  }
  const openCauseCodeDialog = _ => {
    setCauseCodedialog({
      causecode: data.causecode,
      causeCodeDialog: true,
    })
  }

  return (
    <div>
      <Modal
        visible={visible}
        height={400}
        centered
        width={600}
        title={<div>Update Cause Code</div>}
        onOk={onOk}
        onCancel={_ => setVisible(false)}
        okText="Update Cause Code"
      >
        <Tabs type="card">
          <Tabs.TabPane
            tab="Criteria"
            style={{ border: '1px solid #d9d9d9', padding: 10 }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '100px 150px 100px 150px',
                gap: 10,
                border: '0px solid black',
              }}
            >
              <Label>Start Date :</Label>
              <DatePicker
                allowClear={false}
                style={{ width: '100%' }}
                format="MM/DD/YYYY"
                value={data.startDate}
                onChange={d => {
                  setData({ ...data, startDate: d })
                }}
                disabledDate={date =>
                  date.isBefore(startMonth) || date.isAfter(endMonth)
                }
              />
              <Label>End Date :</Label>
              <DatePicker
                allowClear={false}
                style={{ width: '100%' }}
                format="MM/DD/YYYY"
                value={data.endDate}
                onChange={d => {
                  setData({ ...data, endDate: d })
                }}
                disabledDate={
                  date => date.isBefore(startMonth) || date.isAfter(endMonth)
                  //  || date.isBefore(data.startDate)
                }
              />
              <Label>Event Types :</Label>
              <Select
                value={data.eventtype}
                onChange={eventtype => setData({ ...data, eventtype })}
                style={{ gridColumnEnd: 'span 3' }}
                mode="multiple"
                allowClear
              >
                <Select.Option key="ALL" value="ALL">
                  ALL
                </Select.Option>

                {efffEventType.map(d => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.id}
                  </Select.Option>
                ))}
              </Select>
              <Label>Turbine Id :</Label>
              <Select
                value={data.turbineIds}
                onChange={turbineIds => setData({ ...data, turbineIds })}
                style={{ gridColumnEnd: 'span 3' }}
                mode="multiple"
                allowClear
              >
                <Select.Option key="ALL" value="ALL">
                  ALL
                </Select.Option>
                {inverterIdBYPlant.map(({ turbineId }) => (
                  <Select.Option key={turbineId} value={turbineId}>
                    {turbineId}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Tabs.TabPane>
        </Tabs>
        <Divider
          style={{ gridColumnEnd: 'span 4', marginTop: 20, marginBottom: 20 }}
        />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 150px 100px 150px',
            gap: 10,
            // border: '0px solid black',
            padding: 10,
            border: '1px solid #d9d9d9',
          }}
        >
          <Label>Cause Code :</Label>
          <InputNumber
            style={{ width: 'auto', gridColumnEnd: 'span 2' }}
            value={data.causecode}
            onChange={causecode => setData({ ...data, causecode })}
          />
          <Button
            type="primary"
            onClick={openCauseCodeDialog}
            style={{ gridColumnEnd: 'span 1', width: 'fit-content' }}
          >
            Select Cause Code
          </Button>
        </div>

        {causeCodeDialog.causeCodeDialog && (
          <MultiCauseCode
            key="multicausecodelist"
            // style={{ ...inlineStyle }}
            // checkable={false}
            visibleDialog={causeCodeDialog.causeCodeDialog}
            onDialogClose={onCauseCodeDialogClose}
            onCancelAction={onCauseCodeTreeCancel}
            defaultExpandedKeys={
              data.causecode ? causeCodeDialog.selectedKeys : []
            }
            selectedKeys={causeCodeDialog.causeCodeKeyValues}
            selectedValues={causeCodeDialog.causeCodeValues}
            // selectedValues={this.state.causeCodeValues || []}
            unitCodes={[]}
            multiple={false}
            checkable={false}
            selectable
            causeCodeValue={[data.causecode]}
            causeCodeList={causeCodeList}
          />
        )}
      </Modal>
    </div>
  )
}
